<template>
  <div class="mx-5 my-4 p-4 rounded-lg text-sm space-y-2 border" :class="colorClasses[color]">
    <p v-if="title" class="font-medium">{{ title }}</p>
    <slot />
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: 'Hoe werkt dit?' },
  color: { type: String, default: 'blue', validator: v => ['blue', 'purple'].includes(v) }
})

const colorClasses = {
  blue: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-300',
  purple:
    'bg-purple-50 dark:bg-purple-900/20 border-purple-200 dark:border-purple-800 text-purple-800 dark:text-purple-300'
}
</script>
